(() => {
  const SELECTORS = {
    section: '.gallery-wall[data-section-id]',
    filterBtn: '.gallery-wall__filter[data-filter]',
    item: '.gallery-wall__item[data-category]',
    video: 'video[data-gw-video]',
    playBtn: 'button[data-gw-play]'
  };

  function normalizeFilterValue(value) {
    return (value || '').toString().trim();
  }

  function pauseAll(sectionEl) {
    const videos = Array.from(sectionEl.querySelectorAll(SELECTORS.video));
    for (const video of videos) {
      try {
        video.pause();
        video.currentTime = 0;
      } catch (_) {}
    }

    const items = Array.from(sectionEl.querySelectorAll(SELECTORS.item));
    for (const item of items) {
      item.classList.remove('is-playing');
    }
  }

  function pauseOthers(sectionEl, exceptVideo) {
    const videos = Array.from(sectionEl.querySelectorAll(SELECTORS.video));
    for (const video of videos) {
      if (video === exceptVideo) continue;
      try {
        video.pause();
        video.currentTime = 0;
      } catch (_) {}
    }

    const items = Array.from(sectionEl.querySelectorAll(SELECTORS.item));
    for (const item of items) {
      const video = item.querySelector(SELECTORS.video);
      if (!video || video !== exceptVideo) {
        item.classList.remove('is-playing');
      }
    }
  }

  function setActiveFilter(sectionEl, filterValue) {
    const items = Array.from(sectionEl.querySelectorAll(SELECTORS.item));
    const buttons = Array.from(sectionEl.querySelectorAll(SELECTORS.filterBtn));
    const isAll = filterValue === '__all__' || filterValue === '' || filterValue == null;

    for (const btn of buttons) {
      const isActive = normalizeFilterValue(btn.dataset.filter) === (isAll ? '__all__' : filterValue);
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    for (const item of items) {
      const category = normalizeFilterValue(item.dataset.category);
      const matched = isAll ? true : category === filterValue;
      item.classList.toggle('is-hidden', !matched);
    }

    pauseAll(sectionEl);
  }

  function isHoverCapable() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function wireFilters(sectionEl) {
    sectionEl.addEventListener('click', (event) => {
      const btn = event.target.closest(SELECTORS.filterBtn);
      if (!btn || !sectionEl.contains(btn)) return;
      const value = normalizeFilterValue(btn.dataset.filter);
      setActiveFilter(sectionEl, value);
    });

    const defaultFilter = normalizeFilterValue(sectionEl.dataset.defaultFilter);
    if (defaultFilter) {
      setActiveFilter(sectionEl, defaultFilter);
    }
  }

  function wireHoverVideo(sectionEl) {
    if (!isHoverCapable()) return;

    sectionEl.addEventListener(
      'mouseenter',
      async (event) => {
        const card = event.target.closest('.gallery-wall__card');
        if (!card || !sectionEl.contains(card)) return;

        const video = card.querySelector(SELECTORS.video);
        if (!video) return;

        pauseOthers(sectionEl, video);

        try {
          await video.play();
          const item = card.closest(SELECTORS.item);
          if (item) item.classList.add('is-playing');
        } catch (_) {
          // Autoplay can be blocked.
        }
      },
      true
    );

    sectionEl.addEventListener(
      'mouseleave',
      (event) => {
        const card = event.target.closest('.gallery-wall__card');
        if (!card || !sectionEl.contains(card)) return;

        const video = card.querySelector(SELECTORS.video);
        if (!video) return;

        try {
          video.pause();
          video.currentTime = 0;
        } catch (_) {}

        const item = card.closest(SELECTORS.item);
        if (item) item.classList.remove('is-playing');
      },
      true
    );
  }

  function wireMobilePlayButton(sectionEl) {
    sectionEl.addEventListener('click', async (event) => {
      const btn = event.target.closest(SELECTORS.playBtn);
      if (!btn || !sectionEl.contains(btn)) return;

      event.preventDefault();
      event.stopPropagation();

      const card = btn.closest('.gallery-wall__card');
      const video = card ? card.querySelector(SELECTORS.video) : null;
      const item = btn.closest(SELECTORS.item);
      if (!video) return;

      if (!video.paused) {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (_) {}
        if (item) item.classList.remove('is-playing');
        return;
      }

      pauseOthers(sectionEl, video);

      try {
        await video.play();
        if (item) item.classList.add('is-playing');
      } catch (_) {
        // Playback may still be blocked.
      }
    });
  }

  function initSection(sectionEl) {
    if (sectionEl.dataset.gwInitialized === '1') return;
    sectionEl.dataset.gwInitialized = '1';
    wireFilters(sectionEl);
    wireHoverVideo(sectionEl);
    wireMobilePlayButton(sectionEl);
  }

  function initAll() {
    const sections = Array.from(document.querySelectorAll(SELECTORS.section));
    for (const sectionEl of sections) {
      initSection(sectionEl);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
